<form class="f-col blank-form" [formGroup]="prjectDetailsForm" (keydown.enter)="$event.preventDefault()">
    <div class="section-heading">
        <h2 class="h2-heading">{{content?.['b2b.managecompany.pdprojectdetails']}}</h2>
        <a role="button" class="link" *ngIf="tableData.length>0 && !Addnew"
            (click)="addNewCostCenter()"><mat-icon fontSet="material-symbols-outlined" class="edit-icon">add</mat-icon> {{content?.['b2b.managecompany.addnew']}}</a>
    </div>

    <div class="section-content" *ngIf="Addnew">
        <div class="inner-contentsection">
            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.pdprojectname']}}</mat-label>
                        <input matInput formControlName="projectName" (keypress)="blockInvalidCharacters1($event)" (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)">
                        <mat-error *ngIf="prjectDetailsForm.get('projectName').hasError('required')">{{dictionaryContent?.['b2b.managecompany.projectnamereq']}}</mat-error>
                        <mat-error *ngIf="prjectDetailsForm.get('projectName').hasError('maxlength')">{{dictionaryContent?.['b2b.managecompany.projectnamemaxlimit']}}</mat-error>
                        <mat-error *ngIf="prjectDetailsForm.get('projectName').hasError('minlength')">{{dictionaryContent?.['b2b.managecompany.projectnameminlimit']}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.pdprojectcode']}}</mat-label>
                        <input matInput formControlName="projectCode" (keypress)="_CommonService.blockInvalidCharacters1($event)" (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)">
                        <mat-error *ngIf="prjectDetailsForm.get('projectCode').hasError('required')">{{dictionaryContent?.['b2b.managecompany.projectcodereq']}}</mat-error>
                        <mat-error *ngIf="prjectDetailsForm.get('projectCode').hasError('maxlength')">{{dictionaryContent?.['b2b.managecompany.projectcodemaxlimit']}}</mat-error>
                        <mat-error *ngIf="prjectDetailsForm.get('projectCode').hasError('minlength')">{{dictionaryContent?.['b2b.managecompany.projectcodeminlimit']}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label">{{content?.['b2b.managecompany.selectstatus']}}</label>
                        <mat-radio-group aria-label="Select an option" formControlName="status">
                            <mat-radio-button [value]=true selected>{{content?.['b2b.managecompany.active']}}</mat-radio-button>
                            <mat-radio-button [value]=false >{{content?.['b2b.managecompany.inactive']}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>
        </div>

        <div class="inner-action">
            <button mat-button class="button--secondary-small" (click)="onCancel()">{{content?.['b2b.managecompany.cancel']}}</button>
            <button mat-button class="button--primary-small" [class.disabled]="prjectDetailsForm.invalid" (click)="onSave()">{{content?.['b2b.managecompany.save']}}</button>
        </div>
    </div>

    <div class="section-table data-listing" *ngIf="tableData.length>0 && !Addnew">
        <table mat-table [dataSource]="tableData" class="mat-elevation-z0" >
    
            <ng-container matColumnDef="Project Name">
                <th mat-header-cell *matHeaderCellDef>{{content?.['b2b.managecompany.pdprojectname']}}</th>
                <td mat-cell *matCellDef="let element"> {{element.projectName}} </td>
            </ng-container>


            <ng-container matColumnDef="Project Code">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.pdprojectcode']}} </th>
                <td mat-cell *matCellDef="let element"> {{element.projectCode}} </td>
            </ng-container>

 
            <ng-container matColumnDef="Status">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ddstatus']}} </th>
                <td mat-cell *matCellDef="let element" class="status-tag">
                    <span [ngClass]="element.status ? 'status-active' : 'status-inactive'">
                        {{ element.status ? (content?.['b2b.managecompany.active']) : (content?.['b2b.managecompany.inactive']) }}
                    </span>
                </td>
            </ng-container>

  
            <ng-container matColumnDef="Actions">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ddactions']}} </th>
                <td mat-cell *matCellDef="let element" class="onclick-links">
                    <!-- <a class="onclick-cell primary-link" (click)="onEdit(element)">Edit</a>
                    <a class="onclick-cell warm-link" (click)="onRemove(element)">Remove</a> -->
                    <a tabindex="0" role="button" aria-label="Edit item" class="onclick-cell primary-link" (keydown.enter)="onEdit(element)" (click)="onEdit(element)"><mat-icon fontSet="material-symbols-outlined">Edit</mat-icon></a>
                    <a tabindex="0" role="button" aria-label="Remove item" class="onclick-cell warm-link" (keydown.enter)="onRemove(element)" (click)="onRemove(element)"><mat-icon fontSet="material-symbols-outlined">Delete</mat-icon></a>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <ng-container *ngIf="!isLoading && tableData.length==0 && !Addnew">
        <app-cam-empty-state (myEvent)="handleEvent($event)" [heading]="content?.['b2b.managecompany.pdnoprojecttitle']"
            [content]="content?.['b2b.managecompany.pdnoprojectdesc'] "
            [navigateTo]="'/cam/company-management/project-details'">
        </app-cam-empty-state>
    </ng-container>
</form>

<ng-template #selectionWarning>
    <div class="custom-dialog">
        <div class="d-justify-bw">
            <div class="custom-dialog__left">
                <div class="mat-dialog-title custom-dialog__title d-justify-bw">
                    <h2 class="mat-dialog-title"> {{content?.warningList[0]?.title}}</h2>
                    <!-- <div class="custom-overlay-close">
                        <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="CloseDialog(false)">close</mat-icon>
                    </div> -->
                </div>    
                <mat-dialog-content class="custom-dialog__text">
                    <div class="custom-dialog__description">{{content?.['b2b.managecompany.deleteproject'] || 'Are you sure you want to delete this project?'}}</div>
                </mat-dialog-content>    
                <mat-dialog-actions>
                    <div class="dialog-actions-right">
                        <button class="button--secondary-small" mat-button (click)="CloseDialog(false)">{{content?.warningList[0]?.cancelCTAText}}</button>
                        <button class="button--primary-small" mat-button (click)="CloseDialog(true)">{{content?.warningList[0]?.confirmCTAText}}</button>
                    </div>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>